import { loader } from 'graphql.macro'

export default async function addSiteType ({ dataLoaders, variables }) {
  const addSiteTypeSchema = loader('./addSiteType.graphql')
  const siteTypeFields = {
    name: variables.name,
    shortCode: variables.shortCode,
    haulerId: Number(variables.haulerId)
  }

  const response = await dataLoaders.dispatcher.graphQLClient.request(
    addSiteTypeSchema,
    { input: { siteTypeFields } }
  )
  return response.addSiteType
}
